import React, { useState, Fragment, useEffect } from 'react'
import {
  Form,
  Input,
  Button,
  Select,
  message,
  DatePicker,
  Row,
  Col,
  Modal,
  AutoComplete,
} from 'antd'
import {
  JobService,
  HomeService,
  TechnicainService,
  JobGroupService,
  PersonnelService,
  ProjectService,
} from '../../../services'
import {
  Moment,
  disabledDateTime,
  openNotificationWithIcon,
} from '../../../helpers'

import './style.scss'
import { observer, inject } from 'mobx-react'
const TextArea = Input.TextArea
const { Option } = Select

@inject('informStore')
@observer
class JobEdit extends React.Component {
  constructor() {
    super()
    this.state = {
      homes: [],
      home: {},
      projects: [],
      loadingProject: false,
      loadingHome: false,
      loading: false,
      jobId: null,
      job: {},
      currentTime: '',
      errors: {},
      listJobStatus: [],
      technicians: [],
      techniciansTemp: [],
      selectedResponsible: [],
      selectedTechnician: [],
      jobgroups: [],
      form: {},
      startTime: null,
      endTime: null,
      items: [],
      personnels: [],
      listPersonnel: [],
      listHomeItems: [],
    }

    this.formRef = React.createRef()
  }

  async showMessageSuccess(msg, duration = 5) {
    return await message.success(msg, duration)
  }

  /**
   * ข้อมูลสถานะใบแจ้งหนี้
   */
  getJobStatus = () => {
    JobService.getJobStatus().then((rs) => {
      if (rs) {
        const data = rs.data['data']
        this.setState({ listJobStatus: data })
      }
    })
  }
  /**
   * หมวดหมู่งานแจ้งซ่อม
   */

  getJobGroup = () => {
    this.setState({ jobgroups: [] })
    JobGroupService.groups().then((rs) => {
      let data = []
      if (rs) {
        let data = []
        const items = rs.data['data']
        if (items) {
          items.map((item, index) => {
            data.push({
              value: item.id,
              text: item.name,
            })
          })
        }
        this.setState({ jobgroups: data })
      }
    })
  }

  getHomeByProjectId = (projectId) => {
    this.setState({
      disabledSelectHome: true,
      homes: [],
      loadingHome: true,
      home: {},
    })
    ProjectService.getHomesByProject(projectId)
      .then((rs) => {
        if (rs) {
          this.setState({ homes: rs.data['data'], loading: false })
          this.setState({ disabledSelectHome: false, loadingHome: false })
          if (this.props.homeId) {
            this.formRef.current.setFieldsValue({
              home_id: this.props.homeId,
              _home_id: this.props.homeId,
            })
          } else {
            this.state.homes.map((h, key) => {
              if (h.id == this.formRef.current.getFieldValue('home_id')) {
                this.formRef.current.setFieldsValue({
                  home_id: h.id,
                  _home_id: h.id,
                })
              }
            })
          }
          const home = this.state.homes.filter(
            (item) => item.id == this.formRef.current.getFieldValue('home_id'),
          )
          if (home[0]) {
            this.setState({
              home: home[0],
            })
          }
        }
      })
      .catch((err) => this.setState({ loadingHome: false }))
  }

  /**
   *  ข้อมูลพนักงาน
   */
  getPersonnel(params) {
    PersonnelService.search(params)
      .then((rs) => {
        if (rs) {
          let data = []
          const items = rs.data.items
          if (items) {
            items.map((item, index) => {
              data.push({
                value: item.user_id,
                text: item.fullnameTH,
              })
            })
          }
          this.setState({ listPersonnel: data })
        }
      })
      .catch((err) => {})
  }

  handleSubmit = (values) => {
    const jobId = this.props.jobId
    this.setState({ loading: true })
    if (values) {
      // ปรับ timezone ให้ตรงหลัง submit form เนืองจาก เวลามันไม่ตรง
      values.start_time =
        values.start_time && Moment(values.start_time).isValid()
          ? Moment(values.start_time).utc(7)
          : null
      values.end_time =
        values.end_time && Moment(values.start_time).isValid()
          ? Moment(values.end_time).utc(7)
          : null

      console.log('submit', values)

      JobService.update(jobId, values)
        .then((rs) => {
          if (rs) {
            let msg = rs.data['message']
            const data = rs.data.data
            this.setState({
              loading: false,
            })

            openNotificationWithIcon('success', msg)
            this.props.informStore.setJob(data)
            this.props.hideModal()
          }
        })
        .catch((err) => {
          if (err.response) {
            this.setState({
              loading: false,
            })
          }
        })
    }
  }

  onSubmit = () => {
    this.formRef.current.submit()
  }

  componentWillMount() {
    this.setState({
      jobId: this.props.jobId,
      job: this.props.job,
      projects: this.props.projects,
    })

    this.getJobStatus()
    this.getTechnicians()
    this.getJobGroup()
    this.getPersonnel()
  }

  componentDidMount() {
    if (this.state.job.project_id) {
      this.getHomeByProjectId(this.state.job.project_id)
    }
  }

  resetForm = () => {
    this.formRef.current.resetFields()
  }

  onChangeResponsible = (value) => {
    console.clear()
    let responsibleName = ''
    const user = this.state.techniciansTemp.map((item, index) => {
      if (item.id == value) {
        responsibleName = `${item.firstname} ${item.lastname}`
        this.formRef.current.setFieldsValue({
          responsible_name: responsibleName,
        })
      }
    })
  }
  /**
   *  ข้อมูลพนักงาน
   */
  getPersonnel(params) {
    PersonnelService.search(params)
      .then((rs) => {
        if (rs) {
          let data = []
          const items = rs.data.items
          if (items) {
            items.map((item, index) => {
              data.push({
                value: item.user_id,
                text: item.fullnameTH,
              })
            })
          }
          this.setState({ listPersonnel: data })
        }
      })
      .catch((err) => {})
  }
  getTechnicians = () => {
    this.setState({ technicians: [] })
    let currentTechnicians = []
    TechnicainService.all()
      .then((rs) => {
        if (rs) {
          let data = []
          const items = rs.data['data']
          if (items) {
            items.map((item, index) => {
              data.push({
                value: item.id,
                text:
                  item.firstname +
                  ' ' +
                  item.lastname +
                  (item.technician_type
                    ? ' (' + item.technicianTypeName + ')'
                    : null),
              })
            })
          }

          this.setState({
            technicians: data,
            techniciansTemp: items,
          })
          if (this.props.job && this.props.job.technicians) {
            this.props.job.technicians.map((item) => {
              currentTechnicians.push(item.technician_id)
            })
            this.setState({
              selectedTechnician: currentTechnicians,
            })
          }
        }
      })
      .catch((err) => {})
  }

  // optionsResponsible = () => {
  //   let data = [
  //     {
  //       label: 'NOOM',
  //       value: 93,
  //     },
  //   ]
  //   if (this.state.personnels) {
  //     this.state.personnels.map((item) => {
  //       data.push({
  //         label: item.fullnameTH,
  //         value: item.id,
  //       })
  //     })
  //     return data
  //   }

  //   return data
  // }

  onSearchPersonnel = (event) => {
    if (event && event.length >= 3) {
      this.setState({
        loadPersonnel: true,
      })
      setTimeout(() => {
        this.getPersonnel({ q: event })
        this.setState({
          loadPersonnel: false,
        })
        console.log('onSearchPersonnel', event)
      }, 2000)
    }
  }
  onSelectPersonnel = (value) => {
    console.log('onSelectPersonnel', value)
    if (value) {
      this.state.listPersonnel.map((item) => {
        if (Number(item.value) == Number(value)) {
          console.log('name', item.value)
          this.formRef.current.setFieldsValue({
            responsible_id: item.value,
            responsible_name: item.text,
          })
        }
      })
    }
  }
  onDeselectPersonnel = (value) => {
    console.log('onDesearchPersonnel', value)
    this.formRef.current.setFieldsValue({
      responsible_id: null,
    })
  }
  onSelectJobstatus = (value) => {
    console.log('onSelectJobstatus', value)
    this.formRef.current.setFieldsValue({
      job_status: value,
    })
  }
  onSelectHome = (value) => {
    console.log('onSelectHome', value)
    const home = this.state.homes.filter((item) => item.id == value)
    if (home[0]) {
      console.log('home', home[0])
      this.formRef.current.setFieldsValue({
        home_name: `${
          home[0].homeType ? home[0].homeType.name + '#' : ''
        } เลขที่ ${home[0].home_no} | แปลง ${home[0].plan_no}`,
        home_id: value,
      })
    }
  }

  render() {
    const {
      listJobStatus,
      selectedTechnician,
      techniciansTemp,
      technicians,
      personnels,
      listPersonnel,
      loadingHome,
      loadingProject,
      home,
    } = this.state
    const { job } = this.props
    if (job && job.home) {
      // this.setState({
      //   home: job.home
      // })
    }
    const formLayout = 'horizontal'
    const formItemLayout =
      formLayout === 'horizontal'
        ? {
            labelCol: {
              xs: { span: 24 },
              sm: { span: 8 },
              md: { span: 8 },
            },
            wrapperCol: {
              xs: { span: 24 },
              sm: { span: 16 },
              md: { span: 16 },
            },
          }
        : null
    const buttonItemLayout =
      formLayout === 'horizontal'
        ? {
            wrapperCol: {
              xs: { span: 24, offset: 0 },
              sm: { span: 16, offset: 8 },
              sm: { span: 16, offset: 8 },
            },
          }
        : null

    // แสดงวันที่
    const showFormatDate = (datetime) => {
      let date = Moment(datetime)
      if (date.isValid()) {
        return date.format('ll')
      } else {
        return null
      }
    }

    /**
     * รายชื่อช่างค่าเริ่มต้นสำหรับ DropDownList เลือกช่าง
     */
    const currentSelectedTechnician = (job) => {
      let data = []
      if (job.technicians) {
        job.technicians.map((item) => {
          data.push(item.technician_id)
        })
        return data
      }
      return data
    }

    const listHomeItems = this.state.homes.map((item, index) => (
      <Option key={item.id} value={item.id}>
        {(item.homeType ? item.homeType.name : '') +
          (item.plan_no ? ' แปลง ' + item.plan_no : '') +
          (item.home_no ? ' (เลขที่ ' + item.home_no + ')' : '')}
      </Option>
    ))

    return (
      <Fragment>
        <div id="job-form-edit">
          <Modal
            open={this.props.visible}
            onCancel={() => this.props.onCancel()}
            title="แก้ไข"
            footer={
              <Form.Item {...buttonItemLayout}>
                <Button
                  type="primary"
                  htmlType="button"
                  className="submit"
                  onClick={() => this.onSubmit()}
                >
                  บันทึก
                </Button>{' '}
                <Button
                  type="default"
                  htmlType="reset"
                  className="submit"
                  onClick={() => this.resetForm()}
                >
                  รีเซ็ต
                </Button>
              </Form.Item>
            }
          >
            {job ? (
              <React.Fragment>
                <>
                  {job.home && job.home.warrantyExpired.transfer_date ? (
                    <>
                      <div style={{ padding: 7 }}>
                        วันที่โอน:{' '}
                        {job.home.warrantyExpired.transfer_date
                          ? showFormatDate(
                              job.home.warrantyExpired.transfer_date,
                            )
                          : '-'}
                      </div>
                      {job.home && job.home.warrantyExpired ? (
                        <>
                          <div>
                            หมดรับประกัน 1 ปี:{' '}
                            {showFormatDate(job.home.warrantyExpired['1y'])}
                          </div>
                          <div>
                            หมดรับประกันโครงสร้าง (5 ปี):{' '}
                            {showFormatDate(job.home.warrantyExpired['5y'])}
                          </div>
                        </>
                      ) : null}
                    </>
                  ) : null}
                </>
                <Form
                  ref={this.formRef}
                  onFinish={this.handleSubmit}
                  style={{ display: 'block' }}
                  initialValues={{
                    id: job.id,
                    project_id: job.project ? job.project.id : null,
                    project_name: job.project ? job.project.name : null,
                    home_id: job.home_id ? job.home_id : null,
                    _home_id: job.home_id ? job.home_id : null,
                    home_name:
                      job && job.home
                        ? 'เลขที่ ' +
                          job.home.home_no +
                          ' | แปลง ' +
                          job.home.plan_no
                        : 'ไม่ได้ระบุ',
                    group_id: job.group_id,
                    title: job.list,
                    description: job.description,
                    start_time: Moment(job.start_time).isValid() ? Moment(job.start_time) : null,
                    end_time: Moment(job.end_time).isValid() ?  Moment(job.end_time) : null,
                    job_status: job.job_status,
                    technician_name_other: job.technician_name_other,
                    technicians: currentSelectedTechnician(job),
                    responsible_id: job.responsible_id
                      ? job.responsible_id
                      : "",
                    responsible_name: job.responsible_name
                      ? job.responsible_name
                      : "",
                  }}
                >
                  <Row>
                    <Col xs={{ span: 24 }} sm={{ span: 24 }} md={{ span: 24 }}>
                      <Form.Item name="id" {...formItemLayout} noStyle>
                        <Input type="hidden" />
                      </Form.Item>
                      <Form.Item label="ID" {...formItemLayout}>
                        <Input disabled value={job.id} />
                      </Form.Item>
                      <Form.Item
                        label="โครงการ"
                        {...formItemLayout}
                        name="project_name"
                      >
                        <Input type="text" disabled />
                      </Form.Item>
                      <Form.Item
                        label="บ้าน"
                        {...formItemLayout}
                        name="home_name"
                      >
                        <Input type="text" disabled />
                      </Form.Item>
                      <Form.Item
                        shouldUpdate
                        label="รหัสโครงการ"
                        {...formItemLayout}
                        required={true}
                        name="project_id"
                        rules={[{ required: true, message: 'รหัสโครงการ' }]}
                        noStyle
                      >
                        <Input type="hidden" readOnly htmltype="hidden" />
                      </Form.Item>
                      <Form.Item
                        shouldUpdate
                        label="รหัสบ้าน"
                        {...formItemLayout}
                        required={false}
                        name="home_id"
                        rules={[{ required: false, message: 'รหัสบ้าน' }]}
                        noStyle
                      >
                        <Input type="hidden" readOnly htmltype="hidden" />
                      </Form.Item>
                      <Form.Item
                        label="..."
                        {...formItemLayout}
                        name="_home_id"
                        rules={[{ required: false, message: 'เลือกบ้าน' }]}
                      >
                        <Select
                          showSearch
                          allowClear
                          disabled={this.state.disabledSelectHome}
                          placeholder="--เลือกบ้าน--"
                          onChange={this.onSelectHome}
                          filterOption={(input, option) =>
                            option.props.children
                              .toLowerCase()
                              .indexOf(input.toLowerCase()) >= 0
                          }
                        >
                          {this.state.homes ? listHomeItems : null}
                        </Select>
                        {home && home.transfer_date ? (
                          <div style={{ padding: 5 }}>
                            <div>
                              วันที่โอน:{' '}
                              {home.transfer_date
                                ? showFormatDate(home.transfer_date)
                                : '-'}
                            </div>
                            {home && home.warrantyExpired ? (
                              <>
                                <div>
                                  หมดรับประกัน 1 ปี:{' '}
                                  {showFormatDate(home.warrantyExpired['1y'])}
                                </div>
                                <div>
                                  หมดรับประกันโครงสร้าง (5 ปี):{' '}
                                  {showFormatDate(home.warrantyExpired['5y'])}
                                </div>
                              </>
                            ) : null}
                          </div>
                        ) : null}
                      </Form.Item>
                      <Form.Item
                        {...formItemLayout}
                        label="หมวดหมู่"
                        name="group_id"
                      >
                        <Select
                          allowClear
                          placeholder="--เลือกหมวดหมู่--"
                          showSearch
                          filterOption={(input, option) =>
                            option.props.children
                              .toString()
                              .toLowerCase()
                              .indexOf(input.toString().toLowerCase()) >= 0
                          }
                        >
                          {this.state.jobgroups.map((d) => (
                            <Option key={d.value} value={d.value}>
                              {d.text}
                            </Option>
                          ))}
                        </Select>
                      </Form.Item>
                      <Form.Item
                        label="หัวข้อ"
                        {...formItemLayout}
                        name="title"
                      >
                        <Input type="text" placeholder="งาน" />
                      </Form.Item>
                      <Form.Item
                        label="รายละเอียด"
                        {...formItemLayout}
                        name="description"
                      >
                        <TextArea rows={4} placeholder="รายละเอียด" />
                      </Form.Item>
                      <Form.Item
                        label="ตั้งแต่"
                        {...formItemLayout}
                        name="start_time"
                      >
                        <DatePicker
                          placeholder="ตั้งแต่เวลา"
                          style={{ width: '100%' }}
                          showTime={{
                            defaultValue: Moment('09:00:00', 'HH:mm:ss'),
                            minuteStep: 15,
                          }}
                          showToday
                          format="DD/MM/YYYY HH:mm"
                          disabledTime={disabledDateTime}
                          allowClear={true}
                        />
                      </Form.Item>

                      <Form.Item
                        label="ถึงวันที่"
                        {...formItemLayout}
                        name="end_time"
                      >
                        <DatePicker
                          placeholder="ถึงเวลา"
                          style={{ width: '100%' }}
                          showTime={{
                            defaultValue: Moment('09:00:00', 'HH:mm:ss'),
                            minuteStep: 15,
                          }}
                          showToday
                          format="DD/MM/YYYY HH:mm"
                          disabledTime={disabledDateTime}
                          allowClear={true}
                        />
                      </Form.Item>

                      <Form.Item
                        label="ผู้รับผิดชอบ"
                        {...formItemLayout}
                        rules={[
                          { required: false, message: 'ผู้รับผิดชอบงาน' },
                        ]}
                        name="responsible_name"
                      >
                        <Select
                          placeholder="--พิมพ์ค้นหา--"
                          showSearch
                          allowClear
                          optionFilterProp="children"
                          onSearch={this.onSearchPersonnel}
                          onSelect={this.onSelectPersonnel}
                          onDeselect={this.onDeselectPersonnel}
                          filterOption={(input, option) =>
                            option.props.children
                              .toString()
                              .toLowerCase()
                              .indexOf(input.toString().toLowerCase()) >= 0
                          }
                        >
                          {listPersonnel.map((d) => (
                            <Option key={d.value} value={d.value}>
                              {d.text}{' '}
                            </Option>
                          ))}
                        </Select>
                      </Form.Item>
                      <Form.Item
                        shouldUpdate
                        label="ผู้รับผิดชอบ"
                        {...formItemLayout}
                        name="responsible_id"
                        rules={[
                          { required: false, message: 'ผู้รับผิดชอบงาน' },
                        ]}
                        noStyle
                      >
                        <Input type="hidden" readOnly  htmlType="hidden" />
                      </Form.Item>
                      <Form.Item
                        label="ช่าง"
                        {...formItemLayout}
                        name="technicians"
                      >
                        <Select
                          placeholder="--เลือกช่าง--"
                          showSearch
                          allowClear
                          mode="multiple"
                          filterOption={(input, option) =>
                            option.props.children
                              .toString()
                              .toLowerCase()
                              .indexOf(input.toString().toLowerCase()) >= 0
                          }
                        >
                          {this.state.technicians.map((d) => (
                            <Option key={d.value} value={d.value}>
                              {d.text}{' '}
                              {d.technician_type
                                ? '(' + d.technicianTypeName + ')'
                                : null}
                            </Option>
                          ))}
                        </Select>
                      </Form.Item>

                      <Form.Item
                        label="ช่าง/ผู้รับเหมา (อื่น ๆ)"
                        {...formItemLayout}
                        name="technician_name_other"
                        rules={[
                          {
                            required: false,
                            message: 'ช่าง/ผู้รับเหมา (อื่น ๆ)',
                          },
                        ]}
                      >
                        <Input
                          type="text"
                          placeholder="ช่าง/ผู้รับเหมา (อื่น ๆ)"
                        />
                      </Form.Item>
                      <Form.Item
                        label="สถานะ"
                        {...formItemLayout}
                        name="job_status"
                        rules={[
                          {
                            required: true,
                            message: 'สถานะ',
                          },
                        ]}
                      >
                        <Select
                          placeholder="-เลือกสถานะ-"
                          name="job_status"
                          style={{ width: '100%' }}
                          allowClear
                        >
                          {listJobStatus
                            ? listJobStatus.map((status, key) => (
                                <Option key={key} value={status.value}>
                                  {status.text}
                                </Option>
                              ))
                            : null}
                        </Select>
                      </Form.Item>
                    </Col>
                  </Row>
                </Form>
              </React.Fragment>
            ) : null}
          </Modal>
        </div>
      </Fragment>
    )
  }
}

export default JobEdit
